<div class="testlet-action-buttons-alignment">
  @if (config.repeatButton) {
    <app-button
      [config]="repeatButton"
      [trackingId]="'assessment-' + config.buttonTrackingContext + '-repeat'"
      (clicked)="handleButtonClick('repeat')"
    >
      Repeat instructions
      <svg-icon
        src="assets/icons/refresh.svg"
        class="override-center-icon"
        [svgStyle]="{ 'width.px': 24, 'height.px': 24, fill: '#fff' }"
      />
    </app-button>
  }

  @if (config.nextButton) {
    <app-button
      [trackingId]="'assessment-' + config.buttonTrackingContext + '-next'"
      (clicked)="handleButtonClick('next')"
    >
      Next
      <svg-icon
        src="assets/icons/arrow-forward.svg"
        class="override-center-icon"
        [svgStyle]="{ 'width.px': 12, 'height.px': 12, stroke: '#fff' }"
      />
    </app-button>
  }

  @if (config.startTestButton) {
    <app-button
      [trackingId]="'assessment-' + config.buttonTrackingContext + '-start'"
      (clicked)="handleButtonClick('start')"
    >
      Start test
    </app-button>
  }
</div>
